import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  CARDS_PAGE_ADD_PATH,
  CARDS_PAGE_UPDATE_PATH,
  CARDS_PAGE_PATH,
} from "utils/constants/paths";

const CardsListingPage = Loadable(React.lazy(() => import("./View")));
const CardsDetailPage = Loadable(
  React.lazy(() => import("./View/AddOrUpdate")),
);

export const CardsRoute: IRouteItem = {
  path: CARDS_PAGE_PATH,
  element: React.createElement(CardsListingPage),
  name: "Gift Card Listing",
  children: [
    {
      name: "Add / Update",
      path: CARDS_PAGE_UPDATE_PATH,
      element: React.createElement(CardsDetailPage),
      showInDrawer: false,
    },
    {
      path: CARDS_PAGE_ADD_PATH,
      element: React.createElement(CardsDetailPage),
      showInDrawer: false,
    },
  ],
};
